export default {
  location: [1, 2],
  showdate: true,
  bgColor: "#ffff",
  newsTitle: {
    2: "新着情报标题",
    3: "新着情报标题",
    4: "新着情报标题"
  },
  newsTitleColor: "#000000",
  newsTitleFontSize: 20,
  newsListTitleColor: "#1e1e1e",
  newsListHoverTitleColor: "#49548A",
  newsListTitleFontSize: 14,
  newsListMobileBg: "#FFFFF",
  newsListPCBg: "#FFFFF",
  newsMoreVisible: true,
  moreText: {
    "2": "MORE",
    "3": "MORE",
    "4": "MORE"
  },
  moreLink: '',
  mobileShowNum: 4,
  pcShowNum: 4,
  moreTextColor: '#49548a',
  moreTextSize: 16
};